// Generated DB Item type: VariableRelation
export * from './types.js';
export * from './db-def.js';
//# sourceMappingURL=index.js.map